"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDefaultValue = useDefaultValue;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _useDefault3 = require("../_utils/hooks/useDefault");
var _excluded = ["defaultValue", "value", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 表单受控组件中，输入输出的统一规范
 *
 * - `value` 用于输入组件当前值
 * - `onChange` 用于回调组件最新值
 */

/**
 * 表单 `onChange` 事件中，提供的上下文信息
 */

var noop = function noop() {};
function useDefaultValue(props, defaultDefaultValue) {
  //   type ReturnType = Omit<P, 'defaultValue'>;

  var defaultValue = props.defaultValue,
    value = props.value,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? noop : _props$onChange,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useDefault = (0, _useDefault3.useDefault)(value, typeof defaultValue === 'undefined' ? defaultDefaultValue : defaultValue, onChange),
    _useDefault2 = (0, _slicedToArray2.default)(_useDefault, 2),
    finalValue = _useDefault2[0],
    finalOnChange = _useDefault2[1];
  return _objectSpread({
    value: finalValue,
    onChange: finalOnChange
  }, restProps);
}